"use client";

import type React from "react";
import { useState } from "react";

const NewsletterSubscribe = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // TODO: Add email subscription logic here
  };

  return (
    <section className="my-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row md:justify-between gap-8">
          <div>
            <h2 className="text-2xl text-white font-bold">
              Subscribe to CorporateSetup
            </h2>
            <p className="text-lg text-white/70">
              Latest insightful articles delivered straight to your inbox weekly
            </p>
          </div>
          <div className="w-full lg:w-1/2">
            <form
              onSubmit={handleSubmit}
              className="flex flex-col md:flex-row items-stretch"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your Email"
                className="w-full flex-grow px-6 py-3 bg-white text-dark border border-gray-300 text-base focus:outline-none mb-4 md:mb-0"
                aria-label="Email address"
              />
              <button
                type="submit"
                className="w-auto bg-primary-900 text-white px-6 py-3 border border-primary-900 text-base uppercase font-semibold tracking-wide hover:bg-primary-700 transition-colors"
              >
                Subscribe
              </button>
            </form>
            <p className="text-sm text-white/70 mt-2">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSubscribe;
